import { useEffect, useState } from "react";

import { useDataProvider } from "ra-core";

const useEvalConfig = () => {
  const [items, setItems] = useState([]);
  const dataProvider = useDataProvider();
  useEffect(() => {
    dataProvider
      .get("evals/config", {})
      .then(({ data: { data } }) => setItems(data));
  }, [dataProvider]);
  return items;
};

export default useEvalConfig;
